import { AppShell } from '@mantine/core';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: Readonly<LayoutProps>) {
  return (
    <AppShell
      padding={0}
      header={<Navbar />}
      footer={<Footer />}
      styles={(theme) => ({
        main: {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
          paddingTop: 70, // Header height
          paddingBottom: 60, // Footer height
          paddingLeft: theme.spacing.md,
          paddingRight: theme.spacing.md,
          '@media (max-width: 768px)': {
            paddingLeft: theme.spacing.sm,
            paddingRight: theme.spacing.sm,
          }
        },
      })}
    >
      {children}
    </AppShell>
  );
} 